import { DialogContent, Typography } from "@mui/material";

import { PartyDto, PartyReferenceDto } from "@/core/api/generated/v1";

import FieldValue from "../../Form/Display/FieldValue";
import AppModal, { AppModalProps } from "../../Modals/AppModal";
import AppModalTitle from "../../Modals/AppModalTitle";

interface Props {
  trigger: AppModalProps["trigger"];
  party?: PartyDto | PartyReferenceDto;
}

export default function PartyInfoModalWithTrigger({ party, trigger }: Props) {
  // const [isModalOpened, setIsModalOpened] = useState(false);
  // const handleOpen = () => {
  //   setIsModalOpened(true);
  // };
  // const handleClose = () => {
  //   setIsModalOpened(false);
  // };

  return (
    <AppModal
      trigger={trigger}
      triggerParams={{
        isDisableDefaultAction: false,
      }}
      // onClose={handleClose}
      // onOpen={handleOpen}
      // open={isModalOpened}
    >
      <AppModalTitle
        title='Party info'
        withClose
        //onClose={handleClose}
      />
      <DialogContent sx={{ width: "200px" }}>
        <FieldValue label={"Name"} sx={{ mb: 1 }}>
          <Typography component='span' fontSize='inherit' fontWeight='inherit'>
            {party?.name || "-"}
          </Typography>
        </FieldValue>

        <FieldValue label={"Type"} sx={{ mb: 1 }}>
          <Typography component='span' fontSize='inherit' fontWeight='inherit'>
            {party?.type}
          </Typography>
        </FieldValue>

        <FieldValue label={"Is system"} sx={{ mb: 1 }}>
          <Typography component='span' fontSize='inherit' fontWeight='inherit'>
            {party?.isSystem ? "true" : "false"}
          </Typography>
        </FieldValue>
      </DialogContent>
    </AppModal>
  );
}
